module.exports = __webpack_public_path__ + "img/组 6.0d6351e8.png";